<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    withMask?: boolean;
  }>(),
  {
    withMask: true,
  },
);
</script>
<template>
  <div class="w-full h-full relative z-1">
    <div
      v-if="props.modelValue"
      class="w-full h-full absolute z-50 bg-opacity-60 flex items-center justify-center pointer-events-none"
      :class="{ 'bg-gray-300 pointer-events-auto': props.withMask }"
    >
      <a-spin style="width: 50px; height: 50px" animation-duration=".5s" />
    </div>
    <slot />
  </div>
</template>
